import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AlexquareLandingPage from "./pages/AlexquareLandingPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AlexquareLandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
